<template>
	<a v-if="isExternalLink" v-bind="$attrs" :href="to" target="_blank">
		<slot />
	</a>
	<router-link v-else v-bind="$props" custom v-slot="{isActive, href, navigate}">
		<a v-bind="$attrs" :href="href" @click="navigate" :class="isActive ? activeClass : inactiveClass">
			<span
				class="absolute inset-y-0 left-0 w-px"
				:class="[isActive ? 'bg-emerald-500' : 'bg-zinc-900/10 dark:bg-white/5 ']"
			></span>
			<slot />
		</a>
	</router-link>
</template>

<script>
// https://router.vuejs.org/guide/advanced/extending-router-link.html#extending-routerlink
import {RouterLink} from 'vue-router';
import {defineComponent, computed} from 'vue';

export default defineComponent({
	name: 'sidebar-link',
	inheritAttrs: false,

	props: {
		...RouterLink.props,
		inactiveClass: String,
	},
	setup(props) {
		const isExternalLink = computed(() => typeof props.to === 'string' && props.to.startsWith('http'));
		return {isExternalLink};
	},
});
</script>
